<div class="flexed-panel">
  <div class="flexed-panel-item-35 full-size-small-screen" *ngIf="mapMode === mapModes.AllMarkers">
    <div class="flexed-sub small-screen" *ngIf="!isAuthorized && showDashboard">
      <div class="sub-item">
        <mat-card>
          <mat-card-header>{{
            "num-of-municipalities" | translate
            }}</mat-card-header>
          <mat-card-content>{{ getMunicipalityLabel() }}</mat-card-content>
        </mat-card>
      </div>
      <div class="sub-item">
        <mat-card>
          <mat-card-header>
            {{ "num-of-buildings" | translate }}
          </mat-card-header>
          <mat-card-content> {{ getBuildingLabel() }}</mat-card-content>
        </mat-card>
      </div>
      <div class="sub-item">
        <mat-card>
          <mat-card-header>
            {{ "num-of-periods" | translate }}
          </mat-card-header>
          <mat-card-content> {{ getPeriodLabel() }}</mat-card-content>
        </mat-card>
      </div>
    </div>

    <div class="filter-panel padded" *ngIf="mapMode === mapModes.AllMarkers">
      <div class="filter-panel-item-25">
        <mat-form-field>
          <mat-label>{{ "choose-municipality" | translate }}</mat-label>
          <mat-select [formControl]="municipalityForm" multiple (selectionChange)="onSelectedMunicipalities($event)">
            <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllMunicipalities(!selectedAllMunicipalities)">
              {{ 'all-municipalities' |
              translate }}
            </mat-option>
            <mat-option *ngFor="let municipality of municipalities" [value]="municipality.id">
              {{ language == 'en' ? municipality.name : municipality.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-panel-item-25">
        <mat-form-field>
          <mat-label>{{ "choose-period" | translate }}</mat-label>
          <mat-select [formControl]="periodForm" multiple (selectionChange)="onSelectedPeriods($event)">
            <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllPeriods(!selectedAllPeriods)">
              {{ 'all-periods' |
              translate }}
            </mat-option>
            <mat-option *ngFor="let period of periods" [value]="period.id">
              {{ language == 'en' ? period.name : period.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-panel-item-25" *ngIf="{ streetRecommendations: streetRecommendations$ | async } as model">
        <mat-form-field class="example-full-width">
          <input type="text" [placeholder]="'choose-street' | translate" matInput [formControl]="streetForm"
            [matAutocomplete]="auto" />
          <mat-icon color="primary" matSuffix *ngIf="streetForm.value && streetForm.value.length > 0"
            (click)="streetForm.setValue('')"></mat-icon>
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of streetRecommendations" [value]="option">
              {{ option }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div class="filter-panel-item-25">
        <mat-form-field>
          <mat-label>{{ "choose-management" | translate }}</mat-label>
          <mat-select multiple [formControl]="managementForm" (selectionChange)="onSelectedManagement($event)">
            <mat-option *ngFor="let type of buildingManagementTypeEnumValues" [value]="buildingManagementTypes[type]">
              {{ getTypeDescription(buildingManagementTypes[type]) }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-panel-item-25">
        <button mat-raised-button color="primary" mat-raised-button (click)="filterBuildings()">
          <mat-icon>search</mat-icon>
          {{ "search" | translate }}
        </button>
      </div>
    </div>

    <div class="small-screen padded">
      <app-buildings-simple></app-buildings-simple>
    </div>
  </div>
  <div [ngClass]="
      mapMode === mapModes.AllMarkers
        ? 'flexed-panel-item-65 full-size-small-screen'
        : 'flexed-panel-item-100'
    ">
    <div class="mat-elevation-z8">
      <agm-map *ngIf="filteredMarkers && showMarkers" [disableDefaultUI]="false" nativeGoogleMap [zoom]="zoom"
        [latitude]="mapMode === mapModes.SingleMarker ?  singleMarker.latitude : (filteredMarkers && filteredMarkers.length > 0) ? filteredMarkers[0].markers[0].latitude: latitude"
        [longitude]="mapMode === mapModes.SingleMarker ?  singleMarker.longitude: filteredMarkers && filteredMarkers.length > 0 ? filteredMarkers[0].markers[0].longitude: longitude"
        [mapTypeId]="mapTypeId" style="height: 80vh" (mapReady)="onMapReady($event)">
        <div *ngIf="mapMode === mapModes.AllMarkers">
          <agm-marker-cluster *ngFor="let group of filteredMarkers" imagePath="/assets/icons/markers/m">
            <agm-marker [width]="10" [height]="20" [iconUrl]="defaultMarker"
              (markerClick)="showInfo(infoWindow, $event, item)" (mouseOver)="showInfo(infoWindow, $event, item)"
              [color]="event ? 'blue' : 'red'" *ngFor="let item of group.markers" [latitude]="item.latitude"
              [longitude]="item.longitude" [label]="{ color: '#3b4856', fontWeight: 'bold', text: item.label }"
              [labelClass]="marker-label" [styles]="markerStyle">
              <agm-info-window #infoWindow>
              </agm-info-window>
            </agm-marker>
          </agm-marker-cluster>
        </div>

        <agm-marker *ngIf="mapMode === mapModes.SingleMarker" [iconUrl]="defaultMarker" [width]="10" [height]="20"
          (mouseOver)="showInfo(infoWindow, $event)" [color]="event ? 'blue' : 'red'" [latitude]="singleMarker.latitude"
          [longitude]="singleMarker.longitude" [label]="singleMarker.label" [labelClass]="marker-label">
        </agm-marker>
      </agm-map>
    </div>

    <div class="map-type-chooser">
      <mat-form-field>
        <mat-select [(ngModel)]="mapTypeId">
          <mat-option *ngFor="let item of mapTypes" [value]="item">
            <span [ngClass]="item === mapTypeId ? 'bold' : ''">
              {{ item | titlecase }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>


</div>